import myApi from '@/util/api'


export function getDashboard(data) {
    return myApi.getByID(data, "TaskMaster/GetDashboard")
}
export function getDashAssigned(data) {
    return myApi.getByID(data, "TaskMaster/getDashAssigned")
}
export function getDashAssignedBy(data) {
    return myApi.getByID(data, "TaskMaster/GetDashAssignedBy")
}
export function getDashInbox(data) {
    return myApi.getByID(data, "TaskMaster/GetDashInbox")
}


// WEBPACK FOOTER //
// ./src/api/dashboard.js